<template>
  <div>
    <div class="space-y-4">
      <div>
        <div class="flex mb-4">
          <div class="flex justify-between">
            <div class="relative max-w-sm w-full">
              <div class="pr-3">
                <label class="block">
                  <span class="text-gray-700">Search driver</span>
                  <input
                    class="rounded border pl-10 pr-4 py-2 w-full"
                    v-model="searchText"
                    placeholder="Search"
                    @keyup="search"
                  />
                </label>
              </div>
              <ul
                v-if="drivers.length"
                class="absolute max-h-56 mt-1 bg-white border rounded shadow overflow-y-auto"
              >
                <li
                  v-for="(result, index) in drivers"
                  :key="`driver-${index}`"
                  class="px-3 py-2 cursor-pointer hover:bg-blue-500 hover:text-white"
                  @click="filterFinance('driver', result)"
                >
                  {{ result.firstName + " " + result.lastName }},
                  {{ result.phoneNumber }}
                </li>
              </ul>
            </div>
          </div>
          <div class="pr-3">
            <label class="block">
              <span class="text-gray-700">From</span>
              <v-date-picker :value="startDate" v-model="startDate" />
            </label>
          </div>

          <div class="pr-3">
            <label class="block">
              <span class="text-gray-700">To</span>
              <v-date-picker :value="endDate" v-model="endDate" />
            </label>
          </div>

          <div>
            <button
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-5 rounded-full"
              @click="filter"
            >Filter</button>
          </div>
        </div>

        <div class="flex">
          <div class="w-1/2 mr-4">
            <div class="border p-4 rounded-lg space-y-2">
              <h2 class="font-semibold uppercase text-gray-600">Ride</h2>
              <div class="flex flex-wrap -mx-4 -mt-4">
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-indigo-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Normal Trips</p>
                        <p class="text">Fare - {{ finance.normalTripsFare.toFixed(2) }}</p>
                        <p class="text">Net - {{ finance.normalTripsNet.toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-blue-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Corporate Trips</p>
                        <p class="text">Fare - {{ finance.corporateTripsFare.toFixed(2) }}</p>
                        <p class="text">Net - {{ finance.corporateTripsNet.toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-green-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Tax</p>
                        <p
                          class="text-4xl"
                        >{{ (finance.normalTripsTax + finance.corporateTripsTax).toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-teal-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Total</p>
                        <p
                          class="text-1xl"
                        >Fare - {{ (finance.normalTripsFare + finance.corporateTripsFare).toFixed(2) }}</p>
                        <p
                          class="text-1xl"
                        >Net - {{ (finance.normalTripsNet + finance.corporateTripsNet).toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/2">
            <div class="border p-4 rounded-lg space-y-2">
              <h2 class="font-semibold uppercase text-gray-600">Rent</h2>
              <div class="flex flex-wrap -mx-4 -mt-4">
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-indigo-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Rent Fare</p>
                        <p class="text-4xl">{{ finance.rentFare.toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-blue-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Rent Net</p>
                        <p class="text-4xl">{{ finance.rentNet.toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                      style="min-height: 150px;"
                    >
                      <div>
                        <i class="material-icons text-6xl text-green-600">attach_money</i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Rent Tax</p>
                        <p class="text-4xl">{{ finance.rentTax.toFixed(2) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <h2 class="font-semibold uppercase text-gray-600">Payment Summery</h2>
        </div>
        <div class="flex">
          <div class="w-1/3">
            <div class="p-4">
              <div
                class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                style="min-height: 150px;"
              >
                <div>
                  <i class="material-icons text-6xl text-green-600">attach_money</i>
                </div>
                <div class="font-semibold">
                  <p class="text-gray-600">Fare</p>
                  <p
                    class="text-4xl"
                  >{{ (finance.normalTripsFare + finance.corporateTripsFare + finance.rentFare).toFixed(2) }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/3">
            <div class="p-4">
              <div
                class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                style="min-height: 150px;"
              >
                <div>
                  <i class="material-icons text-6xl text-green-600">attach_money</i>
                </div>
                <div class="font-semibold">
                  <p class="text-gray-600">Tax</p>
                  <p
                    class="text-4xl"
                  >{{ (finance.corporateTripsTax + finance.normalTripsTax + finance.rentTax).toFixed(2) }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="w-1/3">
            <div class="p-4">
              <div
                class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                style="min-height: 150px;"
              >
                <div>
                  <i class="material-icons text-6xl text-green-600">attach_money</i>
                </div>
                <div class="font-semibold">
                  <p class="text-gray-600">Net</p>
                  <p
                    class="text-4xl"
                  >{{ (finance.normalTripsNet + finance.corporateTripsNet + finance.rentNet).toFixed(2) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h2 class="font-semibold uppercase text-gray-600">Payment records</h2>
      </div>

      <div class="flex justify-between">
        <div class="w-64">
          <select class="form-select w-full" v-model="selectedFilter" @change="getRides">
            <option :selected="selectedFilter === 'all'" value="all">All</option>
            <option :selected="selectedFilter === 'Completed'" value="Completed">Completed</option>
            <option :selected="selectedFilter === 'Canceled'" value="Canceled">Canceled</option>
            <option :selected="selectedFilter === 'Started'" value="Started">Started</option>
          </select>
        </div>
      </div>

      <div class="inline-block min-w-full shadow rounded-lg mt-4">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Rider Name</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Driver Name</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Pick / Drop Address</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Type</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Vehicle Type</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Status</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Cancel fee</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Total fare</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Discount</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Tax</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Pay to driver</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Collect from driver</th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >Net</th>
            </tr>
          </thead>
          <tbody class="relative" v-if="rides.length">
            <tr v-for="ride in rides" :key="ride._id">
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p
                  class="text-gray-900 whitespace-no-wrap"
                >{{ ride.passenger.firstName + " " + ride.passenger.lastName }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{
                  ride.driver
                  ? ride.driver.firstName + " " + ride.driver.lastName
                  : "-"
                  }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <div>
                  <div class="flex items-center space-x-2">
                    <i class="material-icons text-green-600">location_on</i>
                    <span>{{ ride.pickUpAddress.name }}</span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <i class="material-icons text-red-600">location_on</i>
                    <span>{{ ride.dropOffAddress.name }}</span>
                  </div>
                </div>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.type }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.vehicleType.name }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.status }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.cancelCost.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.fare.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.discount.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.tax.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.payedToDriver.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.collectFromDriver.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ ride.net.toFixed(2) }}</p>
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="13" class="bg-white py-4 text-center text-gray-600 font-semibold">
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No latest rides!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-between items-end">
        <p class="text-gray-600">
          Showing
          <strong>{{ start }}</strong> to
          <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select class="form-select" name="perPage" id="perPage" @change="setPerPage">
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page,
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >{{ page }}</button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      rides: [],
      openDropdown: false,
      loading: true,
      selectedFilter: "all",
      startDate: null,
      searchText: "",
      endDate: null,
      drivers: [],
      passengers: [],
      passengerId: "",
      driverId: "",
      finance: {
        normalTripsFare: 0,
        normalTripsNet: 0,
        normalTripsTax: 0,
        corporateTripsFare: 0,
        corporateTripsNet: 0,
        corporateTripsTax: 0,
        rentFare: 0,
        rentNet: 0,
        rentTax: 0
      }
    };
  },
  watch: {
    currentPage() {
      this.getRides();
    },
    perPage() {
      this.currentPage === 1 ? this.getRides() : (this.currentPage = 1);
    }
  },
  created() {
    var sd = new Date();
    sd.setDate(0);
    sd.setDate(1);
    var ed = new Date();
    ed.setMonth(ed.getMonth() + 1);
    ed.setDate(0);
    this.startDate = sd;
    this.endDate = ed;
    this.getFinance();
    this.getRides();
  },
  computed: {
    driverFilter() {
      return this.$route.query.driver || null;
    },
    riderFilter() {
      return this.$route.query.rider || null;
    }
  },
  methods: {
    filter() {
      this.getFinance();
      this.getRides();
    },
    filterFinance(type, data) {
      this.passengerId = "";
      this.driverId = "";
      this.drivers = [];
      this.passengers = [];

      if (type == "passenger") {
        this.passengerId = data._id;
        this.searchText =
          data.firstName +
          " " +
          data.lastName +
          ", " +
          data.phoneNumber +
          ", " +
          type;
      } else if (type == "driver") {
        this.driverId = data._id;
        this.searchText =
          data.firstName +
          " " +
          data.lastName +
          ", " +
          data.phoneNumber
      }
    },
    getFinance() {
      var path = `finance?start=${this.startDate}&end=${this.endDate}`
      if (this.driverId) {
        path += "&driver=" + this.driverId;
      }
      this.$http
        .get(path)
        .then(response => {
          this.finance = response.data;
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY HH:mm");
    },
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    search: _.debounce(function(e) {
      if (!e.target.value.trim()) {
        this.results = [];
        this.drivers = [];
        this.passengers = [];
        this.driverId = "";
        this.passengerId = "";
        this.getRides();
        return;
      }

      this.$http
        .get(`/drivers/search?limit=5&q=${e.target.value}`)
        .then(response => {
          this.drivers = response.data;
        })
        .catch(err => console.log(err));
    }, 500),
    getRides() {
      this.loading = true;
      var path = `trips?limit=${this.perPage}&page=${this.currentPage}&populate=["driver","passenger","vehicleType"]&start=${this.startDate}&end=${this.endDate}`;

      if (this.driverId) {
        path += "&driver=" + this.driverId;
      }
      if (this.selectedFilter && this.selectedFilter != "all") {
        path += "&status=" + this.selectedFilter;
      }

      console.log(path);

      this.$http
        .get(path)
        .then(response => {
          this.rides = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
